import React, { FC } from 'react';
import { isEditorActive, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { ProductModelDetailFullScreenMediaGalleryModel } from './models/productModelDetailFullScreenMediaGallery.model';
import { GalleryCarouselProps } from './types/productModelDetailFullScreenMediaGallery.types';
import GalleryCarousel from '../@shared/galleryCarousel';
import useExperienceEditorPlaceholder from '../../hooks/useExperienceEditorPlaceholder';
import { isEmptyResponse } from '../../utils/checkEmptyResponse';
import ExperienceEditorComponentPlaceholder from '../@shared/experienceEditorComponentPlaceholder';
import EmptyApiDataMessage from '../@shared/emptyApiDataMessage';
import UnreleasedComponent from '../@shared/unreleasedComponent';

const ProductModelDetailFullScreenMediaGallery: FC<GalleryCarouselProps> = (props) => {
  const isFieldsEmpty = props?.fields && Object.keys(props?.fields).length === 0;
  const apiResponse = !isFieldsEmpty && isEmptyResponse(props);
  const isPlaceholderShown = useExperienceEditorPlaceholder(props);
  const model = new ProductModelDetailFullScreenMediaGalleryModel(props);
  const slides = model.slides;
  const hasSlides = (slides || []).length > 0;

  // Component is unreleased
  if (model.isUnreleased) {
    return <UnreleasedComponent />;
  }

  //  star node opened directly in EE
  if (isPlaceholderShown) {
    return <ExperienceEditorComponentPlaceholder image={model.thumbnailEE} componentName={model.componentName} />;
  }
  // not opened from star node
  // data missing when navigating via from products node
  if (!apiResponse && isEditorActive()) {
    return <EmptyApiDataMessage componentName={model.componentName} />;
  }

  // No data and not in EE
  if (!apiResponse && !isPlaceholderShown && !isEditorActive()) {
    return null;
  }

  if (isFieldsEmpty || !hasSlides) {
    return null;
  }

  return <GalleryCarousel slides={slides} />;
};

export default withSitecoreContext()(ProductModelDetailFullScreenMediaGallery);
